import * as _ from 'lodash';
import { EPendingChangesSelectedAction, EHasChangesStatus } from 'app/core/models/pending-changes.enum';
import { EPendingChangesActions } from '../actions/pending-changes.actions';
import { initialUserGroupState } from 'app/organization/user-groups/store/reducers/current-user-groups.reducers';

export const initialPendingChangesState: IPendingChangesState = {
  action: EPendingChangesSelectedAction.DONOTHING,
  originalUserGroup: initialUserGroupState.currentGroup,
  userGroupModified: initialUserGroupState.currentGroup,
  nextGuid: '',
  hasChanges: EHasChangesStatus.PENDING,
  requestValidation: false
}

export function pendingChangesReducer(state = initialPendingChangesState, action: any): IPendingChangesState {
  switch (action.type) {
    case EPendingChangesActions.SetOriginalUserGroup: {
      const newState = {
        ...initialPendingChangesState,
        originalUserGroup: { ...action.payload }
      };
      return newState;
    }
    case EPendingChangesActions.RequestPendingChanges: {
      const newState = {
        ...state,
        requestValidation: true,
        nextGuid: action.payload
      };
      return newState;
    }
    case EPendingChangesActions.RequestPendingChangesDone: {
      const newState = {
        ...state,
        requestValidation: false
      };
      return newState;
    }
    case EPendingChangesActions.validateChanges: {
      const newState = {
        ...state,
        requestValidation: false,
        action: EPendingChangesSelectedAction.DONOTHING,
        hasChanges: !_.isEqual(
          state.originalUserGroup,
          action.payload.userGroupModified
        )
          ? EHasChangesStatus.HASCHANGES
          : EHasChangesStatus.DONTHASCHANGES,
        userGroupModified: action.payload.userGroupModified
      };
      return newState;
    }

    case EPendingChangesActions.pendingChangesAction: {
      const newState = {
        ...state,
        action: action.payload
      };
      return newState;
    }

    case EPendingChangesActions.ResetProperties: {
      const newState = {
        ...initialPendingChangesState,
        originalUserGroup: { ...state.originalUserGroup }
      };
      return newState;
    }

    case EPendingChangesActions.ResetPendingChangesState: {
      return initialPendingChangesState;
    }

    default:
      return state;
  }
};
